<div class="p-16 m-12 d-flex justify-content-center align-items-center flex-column">
  <img class="m-8" ngSrc="../../../../../assets/images/icons/records.svg" alt="" height="48" width="48">
  <h3>{{ 'COMMON.NO_DATA_FOUND' | translate }}</h3>
</div>
